module.exports = __webpack_public_path__ + "img/weltenburg_hochaltar.90cab7f9.jpg";